/** @jsxImportSource preact */
import { SendIcon } from "./icons";
import type { WidgetTheme } from "./theme";

export interface QuickRepliesProps {
  theme: WidgetTheme;
  replies: string[];
  busy?: boolean;
  onPick?: (reply: string) => void;
  animationDelay?: string;
}

/**
 * 会话最后的追问选项（设计稿 2.6 方向 C）：替买家写好的回答，排在买家说话的一侧、输入框正上方。
 * 样子是描边的买家气泡加发送箭头，点了就按买家消息发出去。
 */
export function QuickReplies({
  theme,
  replies,
  busy = false,
  onPick,
  animationDelay,
}: QuickRepliesProps) {
  return (
    <div
      class="gn-followup gn-quick-replies"
      style={{
        animationDelay,
        "--gn-quick-reply-hover": theme.accentSoft,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 6,
        marginTop: 10,
      }}
    >
      {replies.map((reply) => (
        <button
          key={reply}
          class="gn-quick-reply"
          disabled={busy}
          onClick={() => {
            onPick?.(reply);
          }}
          style={{
            boxSizing: "border-box",
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            maxWidth: "86%",
            minHeight: 44,
            padding: "8px 10px 8px 12px",
            border: `1.5px solid ${theme.accentFill}`,
            borderRadius: theme.bubbleRadius,
            color: theme.accentText,
            cursor: busy ? "default" : "pointer",
            font: "inherit",
            lineHeight: 1.4,
            opacity: busy ? 0.55 : 1,
            overflowWrap: "anywhere",
            textAlign: "start",
          }}
          type="button"
        >
          <span>{reply}</span>
          <SendIcon size={14} strokeWidth={2.2} />
        </button>
      ))}
    </div>
  );
}
